import {memo, ReactElement} from 'react';
import {Box, styled} from '@mui/material';

const StyledImage = styled('img')({
  position: 'absolute',
  top: 0,
  right: 0,
  width: '150px',
  height: 'auto'
});

type Props = {
  stepImage: string | null;
};

function Mask({stepImage}: Props): ReactElement {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        height: '100%',
        '& svg': {
          width: '50%',
          height: 'auto',
          '& path': {
            fill: 'transparent'
          }
        }
      }}
    >
      {stepImage && <StyledImage src={stepImage} alt="step" />}
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 223 300" version="1.1">
        <path
          d="m216.5 150.02a105 143.5 0 0 1 -210 0 105 143.5 0 1 1 210 0z"
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="3"
        />
      </svg>
    </Box>
  );
}

export default memo(Mask);
